<template>
    <div class="wrapper wrapper-content wrapper-boxed">

        <div class="row m-t-xl m-b-md">
            <div class="col-sm-6">
                <h1 class="title">Quotes</h1>
            </div>  
        </div><!-- /.row -->

        <div class="row m-b-md">
            <div class="col-md-4">
                <div class="input-group">
                    <input v-model="search_string" type="text" placeholder="Search quotes" class="input form-control" @keyup.enter="search">
                    <span class="input-group-btn">
                            <button type="button" class="btn btn btn-primary"> <i class="fa fa-search" v-show="!searching"></i> <i class="fa fa-spinner fa-spin" v-show="searching"></i> Search</button>
                    </span>
                </div>
            </div>
        </div><!-- /.row -->

        <ul class="list-detail list-detail-quotes">
			<li class="headings hidden-xs hidden-sm">
				<div class="row">
					<div class="col-md-5 col-lg-4">
						Title
					</div>
					<div class="col-md-4 col-lg-4">
						Client
					</div>
					<div class="col-md-3 col-lg-4 text-right">
						Status
					</div>
				</div><!-- /.row -->
			</li>
			
			<li v-bind:key="quote.uuid" v-for="quote in quotes">
                <router-link tag="a" :to="{ name: 'quotes.show', params: { 'quote_id': quote.id }}" class="row">
				
                    <div class="col-sm-2 col-md-2 col-lg-1">
						<p class="truncate">#{{quote.number}}</p>
					</div>
					<div class="col-sm-4 col-md-3 col-lg-3">
						<p class="truncate title">{{quote.name}}</p>
					</div>
					<div class="col-sm-6 col-md-4 col-lg-4">
						<p class="truncate">{{quote.company}}</p>
					</div>
					<div class="col-6 col-lg-2 hidden-md">
						<span class="date small">{{quote.updated_at | moment("DD/MM/YY")}}</span>
					</div>
					<div class="col-6 col-md-3 col-lg-2">
						<span class="status" v-bind:class="{'status-approved': quote.status == 'completed', 'status-draft': quote.status == 'draft', 'status-sent': quote.status == 'viewed', 'status-declined': quote.status == 'voided'}">{{quoteStatus(quote)}}</span>
					</div>
				</router-link><!-- /.row -->
			</li>
		</ul>
        <lazy-loading v-show="haveQuotes" :reached-bottom="getQuotesForNextPage" :filters="filters" ref="lazyLoading">
          <strong slot="finished" class="text-muted">There are no more quotes.</strong>
        </lazy-loading>
    </div>
</template>

<script>

    import { isEqual, debounce } from 'lodash'
    import { mapState, mapActions } from 'vuex'
    import { Selectize } from 'components/form/input'
    import LazyLoading from 'components/misc/LazyLoading'
    import LaddaButton from 'components/form/input/ladda-button.vue'
    import { notify } from 'utils'
    
    export default {
        components: {
            Selectize,
            LaddaButton,
            LazyLoading
        },

        data: function () {
            return {
                loading: true,
                search_string: '',
                sort: 'asc',
                searching: false
            }
        },
        created: function() {
            this.getQuotes(this.filters)
        },

        watch: {
            filters: debounce(async function (newFilters, oldFilters) {
                if (isEqual(newFilters, oldFilters)) {
                    return
                }

                // Reset the lazy loading component so that it will attempt to load
                // more users as we scroll again.
                const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))

                await this.getQuotes(this.filters).then(resetLazyLoading)
            }, 500),
        },

        computed: {
            ...mapState('quote', {quotes: 'list'}, {pagination: 'pagination'}),

            filters () {
                return {
                    sort: this.sort,
                    search: this.search_string,
                }
            },

            haveQuotes () {
                return this.quotes.length > 0
            },
        },

        methods: {
            ...mapActions('quote', {getQuotes: 'getList', getQuotesForNextPage: 'getListForNextPage'}),

            quoteStatus (quote) {
                if (quote.status == 'completed') return 'Approved'
                if (quote.status == 'voided') return 'Declined'
                if (quote.status == 'draft') return 'Draft'
                if (quote.status == 'viewed') return 'Sent'
            }
        }
    }
</script>

<style scoped>
    .avatar {
        width:45px; 
        margin-right:10px;
        float: left;
    }

    .list-sla > li .client p {
        margin-top: 10px;
    }
</style>